export default {
	"c3e9fc606eca1c9128640e2195cb847e": "There are already signed orders",
	"13ad634c1fdc07c7608baccb98aac1f9": "You have signed a learn first, pay later order. Please visit the order details to view the detailed information.",
	"e4bf091c606d1454ac658f0488399f77": "Go to the order details to view"
}
